import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { DualAxes } from '@ant-design/plots';
import insertCss from 'insert-css';
import styles from './index.module.scss';

const BloodChart = ({ HeightChartObj, chartType, chartDate }) => {
  const [data, setData] = useState([]);
  const [fontSize, setFontSize] = useState(window.innerWidth > 500 ? 25 : 15);
  useEffect(() => {
    const ChartValue = [];
    const week = ['一', '二', '三', '四', '五', '六', '日'];
    if (chartType === 'week') {
      const HeightFilter = HeightChartObj.filter(
        (item) =>
          item.createTime >= moment(chartDate).startOf('W').valueOf() &&
          item.createTime <= moment(chartDate).endOf('W').valueOf()
      );
      for (let i = 0; i < week.length; i++) {
        const BloodWeek = HeightFilter.filter((item) => item.week === i);
        if (BloodWeek.length === 0) {
          ChartValue[i] = { date: week[i] };
        } else {
          ChartValue[i] = { ...BloodWeek[0] };
          ChartValue[i].date = week[i];
        }
      }
      setData(ChartValue);
    } else if (chartType === 'month') {
      const monthEnd = moment(chartDate).endOf('month').date();
      const HeightFilter = HeightChartObj.filter(
        (item) =>
          moment(item.createTime).format('MMMM') ===
          moment(chartDate).format('MMMM')
      );
      for (let i = 0; i < monthEnd; i++) {
        const BloodMonth = HeightFilter.filter(
          (item) => moment(item.createTime).date() === i + 1
        );
        if (BloodMonth.length === 0) {
          ChartValue[i] = { date: (i + 1).toString() };
        } else {
          ChartValue[i] = { ...BloodMonth[0] };
          ChartValue[i].date = (i + 1).toString();
        }
      }
      setData(ChartValue);
      // setData(HeightFilter);
    } else if (chartType === 'date') {
      const HeightFilter = HeightChartObj.filter(
        (item) =>
          moment(item.createTime).format('YYYY/MM/DD') ===
          moment(chartDate).format('YYYY/MM/DD')
      );

      for (let i = 0; i < 24; i++) {
        const BloodDay = HeightFilter.filter(
          (item) => parseInt(moment(item.createTime).format('HH'), 10) === i
        );
        if (BloodDay.length === 0) {
          if (i === 23) {
            ChartValue[i] = { date: '23:59' };
          } else {
            ChartValue[i] = { date: `${i}:00` };
          }
        } else {
          ChartValue[i] = { ...BloodDay[0] };
          if (i === 23) {
            ChartValue[i].date = '23:59';
          } else {
            ChartValue[i].date = `${i}:00`;
          }
        }
      }
      setData(ChartValue);
      // setData(HeightFilter);
    }
  }, [HeightChartObj, chartType, chartDate]);

  insertCss(`
  .custom-tooltip-title {
      margin: 0px 12px;
      padding: 10px 0 8px;
      font-size: 12px;
      border-bottom-style: solid;
      border-bottom-width: thin;
      border-bottom-color: #e9e9e9;
  }

  .custom-tooltip-value {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 8px 12px 0 12px;
    padding-bottom: 8px;
    font-size: 22px;
    text-align: center;
    border-bottom-style: solid;
    border-bottom-width: thin;
    border-bottom-color: #e9e9e9;
    height: 70px;
  }

  .custom-tooltip-temp {
    display: flex;
    position: relative;
    align-items: center;
  }

  .custom-tooltip-temp span:first-child {
    font-size: 12px;
    position: absolute;
    top: 0px;
    color: rgba(0, 0, 0, 0.45)
  }

  .custom-tooltip-temp span:last-child {
    text-align: left;
    margin-top: 10px;
    position: relative;
    color: rgba(0, 0, 0, 0.85)
  }

  .custom-tooltip-wind {
      margin: 8px 12px 12px 12px;
      font-size: 10px;
      color: rgba(0, 0, 0, 0.45);
      display: grid;
      grid-template-columns: 1fr 1fr;
  }

  .tooltip-footer {
    margin: 8px 12px 12px 12px;
    font-size: 10px;
    color: rgba(0, 0, 0, 0.45);
  }

  .background-image {
    background-repeat: no-repeat;
  }

  .rain {
      background-image: url(https://gw.alipayobjects.com/mdn/rms_2274c3/afts/img/A*sg5aT7dY36wAAAAAAAAAAABkARQnAQ);
  }

  .sun {
      background-image: url(https://gw.alipayobjects.com/mdn/rms_2274c3/afts/img/A*gE_hS5JVl5YAAAAAAAAAAABkARQnAQ);
  }

  .cloud {
      background-image: url(https://gw.alipayobjects.com/mdn/rms_2274c3/afts/img/A*BTw4R4O341AAAAAAAAAAAABkARQnAQ);
  }
`);

  const config = {
    data: [data, data],
    xField: 'date',
    yField: ['體重', '身高'],
    // xAxis: {
    //   date: {
    //     range: [0, 1],
    //     tickCount: 5,
    //   },
    // },
    yAxis: {
      value: {
        min: 0,
        max: 200,
        label: {
          style: {
            fontSize,
          },
        },
      },
      身高: {
        min: 0,
        max: 200,
        label: {
          formatter: () => '  ',
        },
      },
      體重: {
        min: 0,
        max: 200,
        label: {
          style: {
            fontSize,
          },
        },
      },
    },
    tooltip: {
      showMarkers: false,
      enterable: true,
      domStyles: {
        'g2-tooltip': {
          width: '150px',
          padding: 0,
        },
      },
      customContent: (title, items) => {
        const data = items[0]?.data || {};
        let titleDom = '';
        if (chartType === 'month' || chartType === 'week') {
          titleDom = `<div class ="custom-tooltip-title">${moment(
            data.createTime
          ).format('YYYY/MM/DD')}(平均)</div>`;
        } else {
          titleDom = `<div class ="custom-tooltip-title">${moment(
            data.createTime
          ).format('MM/DD HH:mm')}</div>`;
        }

        const tempDom = `<div class = "custom-tooltip-value"><div class = "custom-tooltip-temp"><span>身高</span><span>${data.身高}</span></div><div class = "custom-tooltip-temp"><span>體重</span><span>${data.體重}</span></div></div>`;
        const windDom = `<div class = "custom-tooltip-value"><div class = "custom-tooltip-temp"><span>BMI</span><span>${data.BMI}</span></div></div>`;

        return `<div class="">${titleDom}${tempDom}${windDom}</div>`;
      },
    },
    xAxis: {
      label: {
        style: {
          fontSize,
        },
      },
      // range: [0, 1],
      tickCount: chartType === 'date' && 5,
    },
    geometryOptions: [
      {
        geometry: 'column',
        color: '#0063A0',
      },
      {
        geometry: 'line',
        color: '#69B49E',
        lineStyle: {
          lineWidth: 2,
        },
        point: {
          size: 5,
          shape: 'circle',
          style: {
            fill: '#69B49E',
            stroke: '#69B49E',
            lineWidth: 2,
          },
        },
      },
    ],
    legend: false,
  };
  return (
    <>
      <div className={styles.chartBox}>
        <DualAxes {...config} />
      </div>
      <div className={styles.chartLegend}>
        <div className={styles.bloodLegend1} />
        身高
        <div className={styles.HeightLength} />
        體重
      </div>
    </>
  );
};

export default BloodChart;
